// 一对多关系模块（主表 + 明细表）映射
export const MULTI_SHEET_MODULES = {
  purchase_receipt: true,
  production_receipt: true,
  production_issue: true,
  sales_order: true,
  wave_pick: true,
  wms_bom: true,
  purchase_delivery: true,
  sales_delivery: true
}

// 判断是否为多层模块
export function isMultiSheet(module) {
  return !!MULTI_SHEET_MODULES[module]
}
